import { UndoItemType } from '~/_shared/types/undo/undoItem';

export const UNDO_MODEL_VERSIONS = {
  [UndoItemType.REMOVE_PROXIMITY]: ['1'] as const, // Never delete elements from this array. The current version always first
  [UndoItemType.REMOVE_HEATMAP]: ['1'] as const, // Never delete elements from this array. The current version always first
  [UndoItemType.REMOVE_ROUTE]: ['1'] as const, // Never delete elements from this array. The current version always first
} as const;
